<template>
    <div class="down-list">
        <!-- 9指南共识 1 pdf 2 图片  3图文-->
        <div class="download-list-section">
            <div class="download-list-section-box" style="display: flex !important ; align-items: flex-start">
                <div class="download-list-section-box-left">
                    <img v-if="dataItem.content.type == 3" src="/static/two/download_article.svg" alt="" />
                    <img v-else-if="dataItem.content.type == 1" src="/static/two/download_pdf.svg" alt="" />
                    <img v-else src="/static/third/icon_course_download_pic.svg" alt="" />
                </div>
                <div class="download-list-section-box-center">
                    <div class="download-list-section-box-center-title">
                        <span
                            class="download-list-section-title"
                            @click="downloadItem(dataItem)"
                            v-html="dataItem.content.title"
                        ></span>
                    </div>
                    <div class="download-list-section-box-center-desc">
                        <span class="download-list-section-box-center-desc-label">
                            {{ dataItem.created_at.substr(0, 10) }}
                            <span style="margin-left: 8px" v-if="dataItem.content.type == 3"
                                >{{ dataItem.view_count }}人阅读</span
                            >
                            <span style="margin-left: 8px" v-else>{{ dataItem.content.download_count }}人下载</span>
                            <span style="margin-left: 11px" @click.stop="favorite(dataItem)">
                                <img
                                    v-if="dataItem.content.is_favorite"
                                    src="/static/two/download_favorite.svg"
                                    alt=""
                                />
                                <img v-else src="/static/two/download_unfavorite.svg" alt="" />
                                <span v-if="dataItem.content.is_favorite">已收藏</span>
                                <span v-else>收藏</span>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="download-list-section-box-right">
                    <img
                        @click.stop="downloadItem(dataItem)"
                        v-if="dataItem.isDownload && dataItem.content.type != 3"
                        src="/static/two/downloaded.svg"
                        alt=""
                    />
                    <img
                        @click.stop="downloadItem(dataItem)"
                        v-else-if="!dataItem.isDownload && dataItem.content.type != 3"
                        style="margin-right: 10px"
                        src="/static/two/download.svg"
                        alt=""
                    />
                    <div @click.stop="downloadItem(dataItem)" v-else></div>
                </div>
            </div>
        </div>
        <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
            <div class="share-img">
                <img
                    v-if="current_item && current_item.content"
                    :src="current_item.content.link"
                    style="width: 100%"
                    alt=""
                />
            </div>
            <div style="font-family: PingFangSC-Regular; font-size: 14px; color: #ffffff; text-align: center">
                可长按图片保存到相册
            </div>
            <div class="share-cancel-btn" @click="showShareDialog = false">
                <img src="/static/img/course/icon_course_share_close.svg" alt="" />
            </div>
        </van-dialog>
        <van-dialog
            width="345"
            v-model="showEmailVisible"
            show-cancel-button
            @cancel="emailInputValue = ''"
            @confirm="sendEmail"
        >
            <template slot="title">
                <div>请填写邮箱</div>
            </template>
            <template slot="default">
                <div class="text-center" style="margin-top: 20px">请填写邮箱，资料将发送至您的邮箱里</div>
                <div class="position-input-box">
                    <van-field
                        label-class="position-title"
                        input-align="left"
                        v-model="emailInputValue"
                        name="请填写邮箱"
                        placeholder="请填写邮箱"
                        ref="savePositionInput"
                        :rules="[{ required: true }]"
                    />
                </div>
            </template>
        </van-dialog>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showShareDialog: false,
      current_item: {},
      showEmailVisible: false,
      emailInputValue: "",
    }
  },
  created () {
    let email = localStorage.getItem("email")
    if (email != null) {
      this.emailInputValue = email
    }
  },
  methods: {
    goDetail (dataItem) {
      this.$router.push({ name: 'guide-detail', params: { id: dataItem.content.id } })
      Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
      Interface.getData('get', `/course/api/content_relation/${dataItem.id}/view`)
    },
    async downloadItem (item) {
      console.log('item=====', item)
      if (item.content.type == 1) {
        var u = navigator.userAgent
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
          if (item.content.filesize < 20480) {
            await this.getDetailDownload(item.origin_id)
            item.content.download_count += 1
            window.location.href = item.content.link
            return
          }
        }
        this.showEmailVisible = true
        this.current_item = item
      } else if (item.content.type == 3) {
        this.$router.push({ name: 'download-detail', params: { id: item.id } })
      } else {
        this.showShareDialog = true
        this.current_item = item
      }
    },
    async getDetailDownload (id) {
      await Interface.getData('get', Interface.download.download + '/' + id).then((res) => {
        return res
      })
    },
    favorite (item) {
      console.log('item====', item)
      Interface.getData('get', Interface.download.favorite + item.origin_id
      ).then((res) => {
        if (res.code == 0) {
          item.content.is_favorite = !item.content.is_favorite
        }
      })
    },
    sendEmail () {
      let params = {
        id: this.current_item.id,
        email: this.emailInputValue
      }
      localStorage.setItem("email", params.email)
      Interface.getData('post', Interface.download.email, params).then((res) => {
        if (res.code == 0) {
          this.$dialog.alert({
            title: '提示',
            message: '已经记录您的邮箱 , 稍后将发送文件到您的邮箱中',
            confirmButtonText: "确认"
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/components/tags.scss';
@import '@/components/download-list-new.scss';
@import '@/components/share.scss';
.download-list-section {
    width: 355px;
    height: 92px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 8px;
    padding: 0;
    margin-top: 10px;
}
.download-list-section-box-left {
    height: 100%;
    display: flex;
    align-items: center;
    // margin: 2px 0 20px 8px;
    // margin-bottom: 20px;
}
.download-list-section-box-right {
    img {
        margin-left: 0px;
    }
}
.download-list-section-box-right {
    margin-top: 55px;
}
/deep/ .light {
    color: #d81d20;
}

.position-input-box {
    width: 251px;
    margin: 16px 20px;
    background: #f1f2f4;
    border-radius: 6px;
    input {
        background: #f1f2f4;
    }
    .val-cell {
        background: #f1f2f4;
    }
    .van-field {
        background: #f1f2f4;
        width: 100%;
    }
}
.text-center {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #404040;
    letter-spacing: 0;
    text-align: center;
}
// .download-list-section-title{
//   height: 39px;
// }
.download-list-section-box-center {
    height: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/guide.vue